import { useCallback, useEffect, useState } from 'react';
import { getActivityLogs } from '../../../shared/services/activityLogService';

const PAGE_SIZE = 50;

export function useActivityLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState('');
  const [action, setAction] = useState('');
  const [hasMore, setHasMore] = useState(true);

  const refetch = useCallback(() => {
    setLoading(true);
    setError('');
    return getActivityLogs({ action: action || undefined, limit: PAGE_SIZE })
      .then((data) => {
        setLogs(data);
        setHasMore(data.length === PAGE_SIZE);
      })
      .catch((err) => setError(err.message || 'Failed to load activity logs'))
      .finally(() => setLoading(false));
  }, [action]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const loadMore = useCallback(async () => {
    if (logs.length === 0) return;
    setLoadingMore(true);
    try {
      const oldest = logs[logs.length - 1].created_at;
      const more = await getActivityLogs({ action: action || undefined, limit: PAGE_SIZE, before: oldest });
      setLogs((prev) => [...prev, ...more]);
      setHasMore(more.length === PAGE_SIZE);
    } catch (err) {
      setError(err.message || 'Failed to load more logs');
    } finally {
      setLoadingMore(false);
    }
  }, [logs, action]);

  return { logs, loading, loadingMore, error, action, setAction, hasMore, loadMore, refetch };
}
